import { Text } from "dripsy";

export default Text;